import * as React from "react";
import { useApiService, useTl } from "../../../../hooks";
import { CompetitionApi, CompetitionGridDto, CompetitionSearch } from "../../../../api";
import { useGlobalData } from "../../../../contexts";
import { useHistory } from "react-router";
import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import { ERoutes } from "../../../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { ETLCodes } from "../../../../locales";
import { Link } from "react-router-dom";

export interface ICompetitionListProps {}

export const CompetitionList: React.FunctionComponent<ICompetitionListProps> = (props) => {
  const api = useApiService(CompetitionApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();
  const history = useHistory();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: CompetitionGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.competition}/${row.competitionId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.competition}/${row.competitionId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Competition),
        fieldName: "competitionName",
      },
      {
        header: () => t(ETLCodes.RequestNumber),
        fieldName: "requestNumber",
        render: (row: CompetitionGridDto) => (
          <Link target="_blank" to={`${ERoutes.competitionRequest}/${row.competitionRequestId}/detail/view`}>
            {row.requestNumber}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.DateFrom),
        fieldName: "competitionDateFrom",
      },
      {
        header: () => t(ETLCodes.DateTo),
        fieldName: "competitionDateTo",
      },
      {
        header: () => t(ETLCodes.City),
        fieldName: "city",
      },
      {
        header: () => t(ETLCodes.Country),
        fieldName: "country",
      },
    ],
    [history, t]
  );
  const search = React.useCallback(
    (sObj) => api.baseSearch(CompetitionSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );
  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={() => api.getSearchCriterias(true)}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(CompetitionSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId }))
      }
      sortKeys={{ competitionRequestId: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Competitions) }]}
    />
  );
};
